import React, { useState, useEffect } from "react";

const LoadingScreen = () => {
  const [loadingText, setLoadingText] = useState("Loading");
  const loadingPhrases = [
    "Getting things ready",
    "Loading your dashboard",
    "Fetching latest data",
    "Almost there",
    "Setting up your workspace",
  ];

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      setLoadingText(loadingPhrases[currentIndex]);
      currentIndex = (currentIndex + 1) % loadingPhrases.length;
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
      {/* Animated illustration */}
      <div className="loading-illustration">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      {/* Loading text */}
      <div
        style={{
          marginTop: "2rem",
          color: "#2c3e50",
          fontSize: "1.25rem",
          fontWeight: "500",
        }}>
        {loadingText}
        <span className="dots">...</span>
      </div>

      <style>
        {`
          .loading-illustration {
            display: flex;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            animation: bounce 0.5s alternate infinite;
          }

          .circle-1 {
            background: #2563eb;  /* Primary blue */
          }

          .circle-2 {
            background: #3b82f6;  /* Slightly lighter blue */
          }

          .circle-3 {
            background: #60a5fa;  /* Lightest blue */
          }

          .circle:nth-child(2) {
            animation-delay: 0.2s;
          }

          .circle:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes bounce {
            from {
              transform: translateY(0);
            }
            to {
              transform: translateY(-20px);
            }
          }

          .dots {
            display: inline-block;
            animation: ellipsis 1.5s infinite;
            width: 20px;
          }

          @keyframes ellipsis {
            0% { content: '.'; }
            33% { content: '..'; }
            66% { content: '...'; }
            100% { content: '.'; }
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingScreen;
